import SortIcon from '@mui/icons-material/Sort';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from 'react-i18next';

import { EOrder } from 'src/interfaces/Order';

interface Props {
  order: EOrder;
  setOrder: (order: EOrder) => void;
  tooltip?: string;
}

const SortOrderToggle = ({ order, setOrder, tooltip }: Props) => {
  const { t } = useTranslation();
  const label = tooltip ?? t('sorter.toggleOrder');

  return (
    <Tooltip title={label}>
      <IconButton
        aria-label={label}
        size="small"
        onClick={() => setOrder(order === EOrder.asc ? EOrder.desc : EOrder.asc)}
        sx={{
          flexShrink: 0,
          ...(order === EOrder.asc && {
            transform: 'scale(1, -1)',
          }),
        }}
      >
        <SortIcon />
      </IconButton>
    </Tooltip>
  );
};

export default SortOrderToggle;
